import React, { useState, useEffect } from 'react';
import { Table, Spinner, Alert } from '../../shim/reactstrap';
import apiClient from '../../api/ApiClient';

export const AdminSources = () => {
  const [sources, setSources] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadSources();
  }, []);

  const loadSources = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await apiClient.searchSources({ Limit: 100, Offset: 0 });
      setSources(data.Items || []);
    } catch (err) {
      console.error('Failed to load sources:', err);
      setError(err.message || 'Failed to load sources');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>Data Sources</h2>
      </div>

      {error && (
        <Alert color="danger" fade={false}>
          {error}
        </Alert>
      )}

      {loading ? (
        <div className="text-center p-5">
          <Spinner color="primary" />
          <p className="mt-2">Loading sources...</p>
        </div>
      ) : (
        <>
          <div className="mb-3">
            <small className="text-muted">
              Total sources: <strong>{sources.length}</strong>
            </small>
          </div>

          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th style={{ width: '100px' }}>ID</th>
                <th>Name</th>
              </tr>
            </thead>
            <tbody>
              {sources.length === 0 ? (
                <tr>
                  <td colSpan="2" className="text-center text-muted">
                    No sources found
                  </td>
                </tr>
              ) : (
                sources.map((source) => (
                  <tr key={source.Id}>
                    <td>
                      {source.Id}
                    </td>
                    <td>
                      <strong>{source.Name}</strong>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>

          {sources.length > 0 && (
            <div className="mt-3">
              <p className="text-muted small">
                <strong>Note:</strong> Data sources are reference data used throughout the system
                to identify the origin of market data (tickers, candles, sectors, etc.).
                These sources are seeded automatically at application startup and correspond
                to the DataSource enum values in the backend.
              </p>
            </div>
          )}
        </>
      )}
    </div>
  );
};
